import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuildingService } from '../building.service';
import { DetailsBaseComponent } from '../../../../../core/base/components/details-base/details-base.component';
import { BuildingModel } from '../../../../../core/models/building.model';
import { scaleIn400ms } from '../../../../../../@vex/animations/scale-in.animation';
import { fadeInRight400ms } from '../../../../../../@vex/animations/fade-in-right.animation';
import { stagger40ms } from '../../../../../../@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../../../../@vex/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from '../../../../../../@vex/animations/scale-fade-in.animation';
import { AuthService } from '../../../../../core/services/auth.service';
import { ENUM_PERMISSIONS } from '../../../../../core/enums/permission.enum';
import { BuildingStatusEnum, buildingStatusTranslation } from '../../../../../core/enums/building-status.enum';
import { GedDocumentTypeEnum } from '../../../../../core/enums/ged-document-type.enum';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { AddressModel } from '../../../../../core/models/address.model';

@Component({
  selector: 'vex-building-details',
  templateUrl: './building-details.component.html',
  styleUrls: ['./building-details.component.scss'],
  animations: [scaleIn400ms, fadeInRight400ms, stagger40ms, fadeInUp400ms, scaleFadeIn400ms],
})
export class BuildingDetailsComponent extends DetailsBaseComponent<BuildingModel> {
  readonly BuildingStatusEnum = BuildingStatusEnum;
  readonly buildingStatusTranslation = buildingStatusTranslation;
  warningMessages = [];
  hasAddress = false;
  hasInsurance = false;
  hasDeliveryEnergyId = false;

  defaultTabs = [
    {
      label: 'INFORMATIONS',
      route: './',
      routerLinkActiveOptions: { exact: true },
      permission: ENUM_PERMISSIONS.READ_BUILDING_INFORMATION,
    },
    {
      label: 'SALLES',
      route: './room',
      permission: ENUM_PERMISSIONS.READ_BUILDING_ROOM,
    },
    {
      label: 'DOCUMENTS',
      route: './document',
      permission: ENUM_PERMISSIONS.READ_BUILDING_GED,
    },
  ];

  constructor(
    public buildingService: BuildingService,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
  ) {
    super(buildingService, activatedRoute, authService);
  }

  ngOnInit() {
    super.ngOnInit();

    const buildingSubscription = this.buildingService.entity$.subscribe(building => {
      this.loadBuildingAddresses(building._id);
      this.generateWarningTextForBuilding(building);
    });

    const addressSubscription = this.buildingService.address$.subscribe(addresses => {
      this.hasAddress = addresses && addresses.length > 0;
      this.updateWarningMessages();
    });

    this.subscription.add(buildingSubscription);
    this.subscription.add(addressSubscription);
  }

  generateWarningTextForBuilding(entity: BuildingModel) {
    // Vérifier si au moins un point d'énergie est renseigné (nouveau système avec tableau energies)
    const hasEnergies = entity.energies && entity.energies.length > 0;
    // Support de l'ancien système avec deliveryEnergyId
    const hasLegacyEnergyId = entity.deliveryEnergyId && !!entity.deliveryEnergyId?._id;

    this.hasDeliveryEnergyId = hasEnergies || hasLegacyEnergyId;
    this.hasInsurance =
      entity.requiredDocuments &&
      !!entity.requiredDocuments.find(x => x.documentType === GedDocumentTypeEnum.INSURANCE_CERTIFICATE);

    this.updateWarningMessages();
  }

  private updateWarningMessages() {
    this.warningMessages = [];

    if (!this.hasDeliveryEnergyId) {
      this.warningMessages.push('Un point de livraison énergie est nécessaire');
    }

    if (!this.hasAddress) {
      this.warningMessages.push('Une adresse doit être renseignée');
    }

    if (!this.hasInsurance) {
      this.warningMessages.push("Une attestation d'assurance doit être renseignée dans les documents");
    }
  }

  private loadBuildingAddresses(buildingId: string) {
    this.buildingService.loadBuildingAddresses(buildingId);
  }
}
